const endPointesUrls = {
  LOCAL: "http://192.168.1.2:8000/ip_cms",
  UAT: "https://myaic-uat.aicofindia.com/ip_cms",
  LIVE: "https://myaic.aicofindia.com/ip_cms",
  TEST: "http://10.15.22.49:9000/ip_cms",
  STAGING: "https://intstaging.aicofindia.com/ip_cms",
};

const currentUrl = endPointesUrls.LIVE;

let URL = `${currentUrl}`;

const Apiconfigs = {
  upload_emp_image: `${URL}/upload_emp_image`,
  applications: `${URL}/applications`,
  employee_dropdown: `${URL}/employee_dropdown`,
  emp_all_data: `${URL}/emp_all_data`,
  calendar_data: `${URL}/calendar_data`,
  moments: `${URL}/moments`,
  elibrary: `${URL}/elibrary`,
  emagazine: `${URL}/emagazine`,
  read_excel_year_list: `${URL}/read_excel_year_list`,
  announcement_data: `${URL}/announcement_data`,
  birthday: `${URL}/birthday`,
  get_pl: `${URL}/get_pl`,
  read_excel_cards: `${URL}/read_excel_cards`,
  e_magazine: `${URL}/e_magazine`,
  crop_health: `${URL}/crop_health`,
  banner: `${URL}/banner`,
  search_annoucement: `${URL}/search_annoucement`,
  read_excel1: `${URL}/read_excel1`,
  bi_report: `${URL}/bi_report`,
  dpt_repo: `${URL}/dpt_repo`,
  department: `${URL}/department`,
  department_repo: `${URL}/department_repo`,
  learning: `${URL}/learning`,
  other_documents: `${URL}/other_documents`,
  usersagar: `${URL}/user/check_fun`,
  waterMark: `${URL}/waterMark`,
  other_portal_login: `${URL}/other_portal_login`,
  user_details: `${URL}/user_details`,
  shared_document: `${URL}/shared_document`,
  signature_post: `${URL}/signature_post`,
  signature: `${URL}/signature`,
  test: `${URL}/test`,
  contacts: `${URL}/contacts`,
  domain_repo: `${URL}/domain_repo`,
  institutal_repo: `${URL}/institutal_repo`,
  Whistle_Blower: `${URL}/Whistle_Blower`,
  visiting_card: `${URL}/visiting_card`,
  identity_card: `${URL}/identity_card`,
  verify_otp: `${URL}/verify_otp`,
  resend_otp: `${URL}/resend_otp`,
  viewcomplaint: `${URL}/viewcomplaint`,
  viewcomplaintdata: `${URL}/viewcomplaintdata`,
  forward_record: `${URL}/forward_record`,
  send_complain: `${URL}/send_complain`,
  forwarded_list: `${URL}/forwarded_list`,
  url_permissions: `${URL}/url_permissions`,
  send_response: `${URL}/send_response`,
  search_complaint: `${URL}/search_complaint`,
  export_data: `${URL}/export_data`,
  departmental_library_upload: `${URL}/departmental_library_upload`,
  forward_email: `${URL}/forward_email`,
  HOD_approval: `${URL}/HOD_approval`,
  HOD_action: `${URL}/HOD_action`,
  csrf_token: `${URL}/csrf_token`,
  logout: `${URL}/logout`,
  session_update: `${URL}/session_update`,
  // Employee Corner - Forms and Declarations
  employee_forms: `${URL}/employee_forms`,
};

export default Apiconfigs;
